
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container grid grid-4">
        <div>
          <h4>Singumkhonto Wabasebenzi NPC</h4>
          <p style={{ color: '#bdbdbd', fontSize: '0.9rem' }}>
            The Spear Of Workers — independent workers' support, education and case
            assistance across South Africa.
          </p>
        </div>
        <div>
          <h4>Quick Links</h4>
          <ul style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/how-we-work">How We Work</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/rights-library">Rights Library</Link></li>
            <li><Link to="/register">Become a Member</Link></li>
            <li><Link to="/membership-policy">Membership Policy & Disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <h4>Get Involved</h4>
          <ul style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
            <li><Link to="/volunteer">Volunteer</Link></li>
            <li><Link to="/employer-complaint">Report a Workplace Issue</Link></li>
            <li><Link to="/podcast">Podcast Centre</Link></li>
            <li><Link to="/news">News &amp; Announcements</Link></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
            <li>WhatsApp: 071 450 5692</li>
            <li>Call: 079 317 5647 / 072 104 7556</li>
            <li>Email: smartpoint.edustation@gmail.com</li>
            <li>Office: 1363/16 Lindela Wessile Street, Vukuzakhe, Volksrust</li>
            <li><Link to="/contact">Contact Page</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Singumkhonto Wabasebenzi NPC (The Spear Of Workers). All rights reserved.
      </div>
    </footer>
  );
}
